import { Input } from "../ui/input";
import { getFieldError } from "../../utils/validators";

const FormRenderer = ({ fields, values, setValues }) => {
  const update = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const renderField = (field) => {
    const value = values[field.name] || "";

    switch (field.type) {
      case "select":
        return (
          <select
            value={value}
            onChange={(e) => update(field.name, e.target.value)}
            className="border rounded p-2 w-full"
          >
            <option value="">Select {field.label}</option>
            {field.options.map((opt) => (
              <option key={opt.value} value={opt.value}> 
                {opt.label}
              </option>
            ))}
          </select>
        );

      case "textarea":
        return (
          <textarea
            rows="3"
            className="border col-span-2 rounded p-2 w-full"
            value={value}
            onChange={(e) => update(field.name, e.target.value)}
          />
        );

      default:
        return (
          <Input
            type={field.type === "mobile" ? "text" : field.type}
            value={value}
            fieldName={field.name}
            placeholder={field.placeholder}
            maxLength={
              field.type === "mobile"
                ? 10
                : field.name === "prefix"
                  ? 4
                  : undefined
            }
            inputMode={field.type === "mobile" ? "numeric" : undefined}
            onChange={(e) =>
              update(
                field.name,
                field.type === "mobile"
                  ? e.target.value.replace(/\D/g, "")
                  : field.name === "prefix"
                    ? e.target.value.toUpperCase()
                    : e.target.value,
              )
            }
          />
        );
    }
  };

  return (
    <div className={`grid gap-2 sm:gap-4 ${fields.length > 3 ? "grid-cols-2 sm:grid-cols-4 md:grid-cols-3 xl:grid-cols-5" : "grid-cols-1 sm:grid-cols-4 md:grid-cols-5"}`}>
      {fields.map((field) => {
        const value = values[field.name];
        const error = getFieldError(field, value);

        return (
          <div
            key={field.name}
            className={`flex flex-col gap-1 ${(field.name === "address" || field.name === "roleDescription") && "col-span-2 md:col-span-3  xl:col-span-4"} `}
          >
            <label className="font-semibold text-nowrap text-gray-700">
              {field.label} <span className="text-sm text-red-500">*</span>
            </label>

            {renderField(field)}

            {/* {error && <p className="text-sm text-red-500">{error}</p>} */}
            {field.name === "prefix" && (
              <p className="text-sm text-green-500">Enter Exactly 4 Chars</p>
            )}
            {field.name === "roleName" && (
              <p className="text-sm text-green-500">Role name must be unique</p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FormRenderer;
